<template xmlns:v-on="http://www.w3.org/1999/xhtml">
	<div class="col-12 mt-4">
		<b-modal ref="cutLoaderModal"
			hide-footer
			static="true"
			:lazy=true
			:title="$t('Button.loader')">
			<throbber />
			<p class="my-4">{{ $t('Tooltip.message_wait') }}</p>
		</b-modal>
		<b-modal ref="validLoaderModal"
			hide-footer
			static="true"
			:lazy=true
			:title="$t('Button.loader')">
			<throbber />
			<p class="my-4">{{ $t('Tooltip.message_wait') }}</p>
		</b-modal>
		<b-modal ref="insertLoaderModal"
			hide-footer
			static="true"
			:lazy=true
			:title="$t('Button.loader')">
			<throbber />
			<p class="my-4">{{ $t('Tooltip.message_wait') }}</p>
		</b-modal>
		<b-modal ref="insertFileError"
			hide-footer
			static="true"
			:lazy=true
			:title="$t('Button.loader')">
			<p class="my-4">{{ $t('VideoEdition.fileType') }}</p>
		</b-modal>
		<b-modal ref="modalError"
			hide-footer
			static="true"
			:lazy=true
			:title="$t('Errors.error')">
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>
		<b-tooltip :disabled="stateHelp === false"
			target="browse-button">
			{{ $t('Tooltip.insertion') }}
		</b-tooltip>
		<b-tooltip :disabled="stateHelp === false"
			target="valid-cut-video-button">
			{{ $t('Tooltip.cut') }}
		</b-tooltip>
		<div class="row">
			<div class="col-6" style="margin: 0 auto;">
				<div class="embed-responsive embed-responsive-16by9"
					v-if="this.compilLoader === false">
					<video class="embed-responsive-item"
						:src="videoAbsolutePath"
						id="video"
						ref="videoplayer"></video>
				</div>
				<div v-else-if="this.compilLoader === true">
					<p>{{ $t('Button.loader') }}</p>
				</div>

			</div>

		</div>
		<div class="row">
			<div class="col-12">
				<div class="center-align">

					<slider class="sliderClass"
						id="sliderId"
						ref="slider"
						@click.native="setVideoCurrentTime"
					/>
					<div class="col-4">

						<b-row>
							<b-col class="text-center editorElement">
								<i class="editorButton"
									v-on:click.prevent="restartVideo"><img src="static/images/cut_undo.png" alt="Annuler" /></i>
							</b-col>
							<b-col class="text-center editorElement">
								<a href="#"
									v-on:click.prevent="playVideo"
									:class="{'notActive' : this.isCuted}"> <i class="editorButton"
									v-if="!videoPlayed"><img src="static/images/cut_play.png" alt="Lecture" /></i>
									<i class="editorButton"
										v-if="videoPlayed"><img src="static/images/cut_pause.png" alt="Pause" /></i>
								</a>
							</b-col>
							<b-col class="text-center editorElement">
								<a href="#"> <i class="editorButton"
									@click.prevent="enableVideoVolume"><img src="static/images/cut_volume.png" alt="Volume" /></i>
								</a>
								<vue-slider
									v-model="volumeValue"
									v-if="isVolumeSet"
									:fixed="fixed"
									:tooltip="'none'"
									:min="0"
									:max="100"
									:height="10"
									:interval="interval"
									:processStyle="{'backgroundColor': '#224B93'}"
									class="slider-class" />
								<SliderVolume
									v-model="volumeValue"
									v-if="isVolumeSet"
									ref="sliderVolume"
									@click.native="setPlayerVolume" />
							</b-col>
							<b-col class="text-center editorElement">
								<i v-if="!(uploadedFiles.length !== 0 || mode_slider_select || needs_validation)" class="editorButton"
									@click="selectIntervalCutVideo($event)"
									ref="editorCut"><img src="static/images/cut.png" alt="Couper" /></i>
							</b-col>
							<b-col class="text-center editorElement">
								<i v-if="mode_slider_select && !needs_validation" class="editorButton validEditorButton"
									@click="handler(optionCut)"
									id="valid-cut-video-button"
									ref="editorValidation"><img src="static/images/cut_check.png" alt="Valider" /></i>
							</b-col>
						</b-row>
					</div>
				</div>
			</div>
		</div>
		<div class="row" style="margin-top: 30px;">
			<div class="col-6" :class="{ file_loaded: uploadedFiles.length > 0 || needs_validation }" v-if="this.optionCut === 0">
				<b-alert v-if="errors !== 0"
					:show="dismissCountDown"
					dismissible
					variant="danger"
					@dismissed="dismissCountDown=0"
					@dismiss-count-down="countDownChanged">
					<h4 class="alert-heading">Erreur !</h4>
					<p>{{ $t('VideoEdition.maxInsertDuration') }}</p>
				</b-alert>
				<div v-if="false">
					<form ref="dragDropFile">
						{{ $t('VideoEdition.selectCutingLabel') }}
						<div class="custom-file">
							<input type="file"
								:disabled="uploadedFiles.length > 0 || disable_upload || needs_validation"
								id="file"
								accept="video/mp4, video/quicktime, image/jpeg, image/png"
								ref="fileUpload"
								v-on:change="handleFileUploadCut()"
								style="width: 150px"
								data-buttonText="Your label here." /> <label class="custom-file-label"
							for="file"
							id="browse-button">{{ $t('VideoEdition.selectCutingPlan') }}</label>
							<audio class="mx-auto"
								ref="audio"
								id="audio"></audio>
						</div>
					</form>
					<br />
				</div>
			</div>
			<div class="col-6" v-if="uploadedFiles.length !== 0 && this.optionCut === 0">
				<div class="uploadZone">
					<div v-for="(file, key) in uploadedFiles"
						class="file-listing"
						v-bind:key="key">
						<div ref="divUploadFiles"
							id="divMini">
							<div>
								<p v-if="file['type'] === 'video'">
									<img :src="image_source" height="50px" /> {{ $t('VideoEdition.duration') }} {{ file['video_duration'].toFixed(2) }}s
								</p>
								<p v-else><img :src="image_source" height="50px" />Image</p>
							</div>
							<div class="btn-controls">
								<button id="insertBtn"
									v-if="insert_mode"
									class="file-edit-btn"
									v-on:click.prevent="insertFile(key)">{{ $t('VideoEdition.insert') }}
								</button>

								<button id="suppressBtn"
									class="file-edit-btn btn-undo"
									v-on:click.prevent="removeFile( key )">{{ $t('VideoEdition.suppress') }}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div style="margin-top: 2rem">
				<a href="#"
					:class="{ 'disabled': !needs_validation, 'btn btn-valid' : true }"
					@click.prevent="validEdition">{{ $t('VideoEdition.validCut') }}</a>
			</div>
			<div style="margin-top: 2rem;margin-left:1rem">
				<a href="#"
					@click.prevent="goBack"
					class="btn btn-cancel">{{ $t("VideoEdition.suppress") }}</a>
			</div>
		</div>
	</div>
</template>

<script>
import Slider from "../ui/Slider";
import Flickity from "vue-flickity";
import axios from "axios";
import VueSlider from "vue-slider-component";
import {EventBus} from "../../event/event-bus";
import throbber from "@/components/ui/throbber";
import lottie_error from "@/components/ui/lottie_error";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "VideoEdition2",
	components: {
		Slider,
		Flickity,
		VueSlider,
		throbber,
		lottie_error,
	},
	data() {
		return {
			flickityOptions: {
				initialIndex: 2,
				prevNextButtons: true,
				wrapAround: true,
				draggable: false,
				pageDots: false,
			},
			scaleFactor: 0.25,
			optionCut: 0,
			validation_button: false,

			mode_file_added: false,
			mode_slider_select: false,
			needs_validation: false,

			errors: 0,
			text_error: "",
			isVolumeSet: false,
			errorArray: [],
			dismissSecs: 5,
			dismissCountDown: 0,
			value: 0,
			backText: "form_logic.back_button",
			showDismissibleAlert: false,
			compilLoader: false,
			uploadedFiles: [],
			selected: -1,
			overlayStatus: false,
			videoPlayed: false,
			image_source: "./static/images/picto_insert_video.png",
			video: [],
			video_absolute_url: "",
			video_relative_url: "",
			oldVideoName: "",
			videoName: "",
			isCuted: false,
			stateHelp: true,
			disable_upload: false,
			insert_mode: true,
		};
	},
	computed: {
		videoAbsolutePath: {
			get() {
				return this.video_absolute_url;
			},
			set(v) {
				this.video_absolute_url = v;
			},
		},
		videoRelativePath: {
			get() {
				return this.video_relative_url;
			},
			set(v) {
				this.video_relative_url = v;
			},
		},
		videoModifiedName: {
			get() {
				return this.videoName;
			},
			set(v) {
				this.videoName = v;
			},
		},
		volumeValue: {
			get() {
				return this.value;
			},
			set(v) {
				this.value = v;
				this.$refs.videoplayer.volume = v / 100;
			},
		},
	},
	beforeRouteEnter(to, from, next) {
		// TODO: add speech/ambiance differentiation
		let api_path;
		if (to.params.step_type === "s") {
			api_path = "stepSpeeches";
		}
		else {
			api_path = "stepAmbiances";
		}

		axios.get(BASE_URL + "/public/api/" + api_path + "/" + to.params.stepId + "/query/" + to.params.filename,
			{
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			}).then(response => {
			next(vm => {
				let video_url = BASE_URL + "/public/storage/videos/" + response.data.url + "#" + new Date().getTime();
				let video_data = response.data.data;

				vm.video.push({video_duration: video_data.duration, video_url: video_url});
				vm.videoAbsolutePath = video_url;
				vm.videoModifiedName = response.data.url;
				vm.$refs.slider.setMax(video_data.duration);
			});
		}).catch(error => {
			this.text_error = this.$root.$t("Errors.message_project") + error;
			this.$refs.modalError.show();
		});
	},
	mounted() {
		let slider = this.$refs.slider;
		let player = this.$refs.videoplayer;
		player.addEventListener("timeupdate", function (e) {
			e.preventDefault();
			if (!isNaN(slider.value)) {
				let valueSlider = this.currentTime * 100 / 100;
				slider.setValue(valueSlider);
			}
		});
		this.volumeValue = (this.$refs.videoplayer.volume * 100);
	},
	created() {
		let $this = this;
		EventBus.$on("setHelpSpeech", function (value) {
			$this.stateHelp = value;
		});
	},
	deactivated() {
		this.$destroy();
	},
	methods: {
		validEdition: function () {
			let api_path;
			if (this.$route.params.step_type === "s") {
				api_path = "stepSpeeches";
			}
			else {
				api_path = "stepAmbiances";
			}

			let $this = this;
			$this.$refs.validLoaderModal.show();

			axios.get(BASE_URL + "/public/api/" + api_path + "/" + $this.$route.params.stepId + "/cut/" + $this.$route.params.filename + "/confirm",
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(function () {
				$this.$refs.validLoaderModal.hide();
				$this.goBack();
			})
			.catch(error => {
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
				this.$refs.validLoaderModal.hide();
			});

		},
		goBack() {
			this.isCuted = false;
			let $this = this;
			$this.$router.push({name: "ProjectEdition"});
		},
		isSelected(index) {
			return this.selected === index;
		},
		handleFileUpload() {
			let $this = this;
			$this.isCuted = true;
			let inputFiles;
			if (this.insert_mode) {
				inputFiles = this.$refs.fileUpload.files;
			}
			else {
				inputFiles = this.$refs.fileUploadAppend.files;
			}

			let player = document.createElement("video");
			if (this.uploadedFiles.length > 1) {
				this.uploadedFiles.splice(0, this.uploadedFiles.length);
			}

			for (let i = 0; i <= inputFiles.length - 1; i++) {
				if (inputFiles[i].type.startsWith("image")) {
					$this.uploadedFiles.push({
						id: i,
						type: "image",
						filename: inputFiles[i].name,
						file: inputFiles[i],
					});
				}
				else {
					player.setAttribute("width", "320");
					player.setAttribute("height", "250");
					player.src = URL.createObjectURL(inputFiles[i]);
					player.onloadeddata = function () {
						// let videoDuration = player.duration;
						$this.uploadedFiles.push({
							id: i,
							type: "video",
							filename: inputFiles[i].name,
							file: inputFiles[i],
							video_duration: player.duration,
						});

						URL.revokeObjectURL(inputFiles[i]);
						player.pause();
						player.src = "";
						player.load();
					};
				}
			}
		},
		handleFileUploadCut() {
			this.insert_mode = true;
			this.handleFileUpload();
		},
		handleFileUploadAppend() {
			this.insert_mode = false;
			this.handleFileUpload();
		},
		insertFile(key) {
			this.disable_upload = true;
			this.mode_slider_select = true;

			let slider = this.$refs.slider;
			if (this.uploadedFiles[key]["type"] === "video") {
				let duration = this.uploadedFiles[key]["video_duration"];
				try { // valid
					if (duration < slider.getMax()) {
						this.uploadedFiles[key]["isValidate"] = true;
						slider.setValue([slider.getValue(), (slider.getValue() + duration)]);
						slider.setFixed(true);
						slider.setBackgroundColor("#224B93");
						this.uploadedFiles.splice(key, 1);
					}
					else {
						this.uploadedFiles[key]["isValidate"] = true;
						slider.setValue([0, slider.getMax()]);
						slider.setFixed(true);
						slider.setBackgroundColor("#224B93");
						this.uploadedFiles.splice(key, 1);
						// this.disable_upload = false;
						// this.errors = 1;
						// this.showAlert();
						// this.uploadedFiles.splice(key, 1);
					}
				} catch(error) {
					this.disable_upload = false;
					console.log(error);
				}
			}
			else {
				this.uploadedFiles[key]["isValidate"] = true;
				slider.setValue([slider.getValue(), (slider.getValue() + 5)]);
				slider.setFixed(false);
				slider.setBackgroundColor("#224B93");
				this.uploadedFiles.splice(key, 1);
			}
			// this.$refs.editorValidation.style.display = "inline-block";
			this.validation_button = true;
			// if (typeof this.$refs.editorCut !== "undefined") {
			// 	this.$refs.editorCut.style.display = "none";
			// }
		},
		removeFile(key) {
			let slider = this.$refs.slider;
			slider.setValue(0);
			slider.setFixed(false);
			this.uploadedFiles.splice(key, 1);
		},
		selectIntervalCutVideo: function (e) {
			this.mode_slider_select = true;

			this.optionCut = 1;
			this.disable_upload = true;
			this.isCuted = true;
			// this.$refs.editorValidation.style.display = "inline-block";
			this.validation_button = true;
			let value = this.$refs.slider.getValue();
			console.log(value);
			this.$refs.slider.setValue([value, value]);
			this.$refs.slider.setBackgroundColor("#BF1B2880");
			// this.$refs.slider.setDotStyle([{"backgroundColor": "#00911C"}, {"backgroundColor": "#BF1B28"}])
			this.$refs.slider.setDotColor("#BF1B28");
		},
		handler(value) {
			if (value === 1) {
				this.cutVideo();
			}
			else {
				this.insertVideo();
			}
			this.backText = "form_logic.undo_button";
		},
		cutVideo() {
			this.$refs.cutLoaderModal.show();
			let $this = this;

			let api_path;
			if (this.$route.params.step_type === "s") {
				api_path = "stepSpeeches";
			}
			else {
				api_path = "stepAmbiances";
			}

			axios.post(BASE_URL + "/public/api/" + api_path + "/" + $this.$route.params.stepId + "/cut/" + $this.$route.params.filename,
				{
					startTime: $this.$refs.slider.getValue()[0],
					duration: $this.$refs.slider.getValue()[1],
				},
				{
					headers: {"Authorization": sessionStorage.getItem("auth")},
				}).then(function (response) {
				$this.videoAbsolutePath = response.data.url;
				// $this.videoRelativePath = response.data.video_relative_url;
				// $this.videoModifiedName = response.data.videoName;
				$this.$refs.slider.setMax(response.data.duration);
				$this.$refs.cutLoaderModal.hide();
				$this.isCuted = false;

				$this.needs_validation = true;
			})
			.catch(error => {
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});

			// this.optionCut = 0;
			this.$refs.slider.setValue(0);
			this.$refs.slider.setDotColor("#FFFFFF");
			// this.$refs.editorValidation.style.display = "none";
			this.validation_button = false;

			if (typeof this.$refs.editorCut !== "undefined") {
				this.$refs.editorCut.style.display = "none";
			}
			this.$refs.slider.setBackgroundColor("#CCCCCC");
		},
		insertVideo() {
			let $this = this;
			let video = this.$refs.fileUpload.files[0];
			let bodyFormData = new FormData();
			bodyFormData.append("videoToInsert", video);
			bodyFormData.append("file", this.$route.params.filename);
			bodyFormData.append("startTime", this.$refs.slider.getValue()[0]);
			bodyFormData.append("endTime", this.$refs.slider.getValue()[1]);
			if (video) {
				this.$refs.insertLoaderModal.show();

				let api_path;
				if (this.$route.params.step_type === "s") {
					api_path = "stepSpeeches";
				}
				else {
					api_path = "stepAmbiances";
				}

				axios.post(BASE_URL + "/public/api/" + api_path + "/" + $this.$route.params.stepId + "/insert/" + $this.$route.params.filename,
					bodyFormData,
					{
						headers: {
							"Content-Type": "multipart/form-data",
							"Authorization": sessionStorage.getItem("auth"),
						},
					},
				).then(function (response) {
					$this.videoAbsolutePath = response.data.data;
					$this.videoRelativePath = response.data.video_relative_url;
					$this.videoModifiedName = response.data.videoName;
					$this.$refs.slider.setMax(response.data.duration);
					$this.$refs.insertLoaderModal.hide();
					$this.isCuted = false;

					$this.needs_validation = true;
				})
				.catch(error => {
					this.$refs.insertLoaderModal.hide();
					this.text_error = this.$root.$t("Errors.message_project") + error;
					this.$refs.modalError.show();

					this.isCuted = true;
				});
			}
			this.optionCut = 0;
			this.$refs.slider.setValue(0);
			this.$refs.slider.setDotColor("#FFFFFF");
			// this.$refs.editorValidation.style.display = "none";
			this.validation_button = false;
		},

		playVideo() {
			if (!this.isCuted) {
				let player = this.$refs.videoplayer;
				this.$refs.slider.setBackgroundColor("#CCCCCC");
				if (player.paused) {
					player.play();
					this.videoPlayed = true;
					this.$refs.slider.setValue(player.currentTime);
				}
				else {
					player.pause();
					this.isCuted = false;
					this.videoPlayed = false;
				}
			}
		},
		restartVideo() {
			this.mode_slider_select = false;
			this.mode_file_added = false;
			this.needs_validation = false;

			this.optionCut = 0;
			this.isCuted = false;
			this.validation_button = false;
			// this.uploadedFiles = [];
			this.disable_upload = false;

			let player = document.getElementById("video");
			player.currentTime = 0;
			// this.$refs.editorValidation.style.display = "none";

			this.$refs.slider.setFixed(false);
			this.$refs.slider.setValue(0);
			this.$refs.slider.setBackgroundColor("#CCCCCC");
			this.$refs.slider.setDotColor("#FFFFFF");
			player.pause();
			this.videoPlayed = false;
		},
		setVideoCurrentTime() {
			if (isNaN(this.$refs.slider.value)) {
				this.$refs.videoplayer.currentTime = this.$refs.slider.getValue()[0];
				if (this.$refs.slider.getValue()[1] < this.$refs.slider.getValue()[0]) {
					let value2 = this.$refs.slider.getValue()[0];
					this.$refs.slider.setValue(this.$refs.slider.getValue()[0], value2);
				}
			}
			else {
				this.$refs.videoplayer.currentTime = this.$refs.slider.getValue();
			}
		},
		next() {
			this.$refs.flickity.next();
		},
		previous: function () {
			this.$refs.flickity.previous();
		},
		countDownChanged(dismissCountDown) {
			this.dismissCountDown = dismissCountDown;
		},
		showAlert() {
			this.dismissCountDown = this.dismissSecs;
		},
		enableVideoVolume() {
			if (this.isVolumeSet === false) {
				this.isVolumeSet = true;
			}
			else if (this.isVolumeSet === true) {
				this.isVolumeSet = false;
			}
		},
		setPlayerVolume() {
			this.volumeValue = this.$refs.sliderVolume.getValue();
			this.$refs.videoplayer.volume = (this.volumeValue / 100);
		},
	},
};
</script>

<style scoped>
.embed-responsive {
	border: none;
	border-radius: var(--big-border-radius);
	box-shadow: 0 0 15px #00000033;
}

.notActive {
	opacity: .5;
}

.sliderClass {
	margin: 40px 0 30px;
}

.editorElement {
	padding: 0;
}

.card {
	border-radius: 10px;
	overflow: hidden;
	width: 265px;
}

.editorButton {
	margin-left: 10px;
	cursor: pointer;
	color: #224B93;
}

form.dragForm {
	display: block;
	height: 100px;
	width: 85%;
	background: #CCCCCC;
	margin: 20px auto 0;
	text-align: center;
	line-height: 400px;
	border-radius: 4px;
}

div.file-listing {
	width: 400px;
	margin: 0;
	padding: 0;
}

div.file-listing img {
	height: 50px;
}

div.remove-container {
	text-align: center;
}

div.remove-container a {
	color: red;
	cursor: pointer;
}

a.submit-button {
	display: block;
	margin: 20px auto 0;
	text-align: center;
	width: 200px;
	padding: 10px;
	text-transform: uppercase;
	color: white;
	font-weight: bold;
}

.file_loaded {
	opacity: 30%;
	display: none;
}

.uploadZone {
	margin: 10px 0 0;
}

.file-edit-btn {
	text-align: center;
	padding: 5px 10px;
	margin: 0 5px 0 0;
	color: white;
	font-weight: bold;
	border: solid 1px white;
	background-color: #224B93;
}

.btn-undo {
	background-color: #000000AA;
}

.btn-controls {
	display: flex;
}

.btn-cancel {
	background-color: var(--color-cancel);
	border-color: var(--color-cancel);
	color: var(--text-cancel);
}

.btn-valid {
	background-color: var(--color-validation);
	border-color: var(--color-validation);
	color: var(--text-validation);
}

.custom-file-label::after {
	content: "Parcourir"
}

</style>
